/*
 * 管理由 UniApp 调用的 window 全局回调。
 * 多个 Vue 组件可以同时注册同名回调，组件销毁时只移除自己的处理器。
 */

const dispatchers = new Map()

export function registerGlobalCallback(name, handler) {
  let entry = dispatchers.get(name)

  if (!entry) {
    const previous = window[name]
    const dispatcher = (payload) => {
      previous?.(payload)
      entry.handlers.forEach((callback) => callback(payload))
    }

    entry = { handlers: new Set(), previous, dispatcher }
    dispatchers.set(name, entry)
    window[name] = dispatcher
  }

  entry.handlers.add(handler)

  return () => {
    const current = dispatchers.get(name)
    if (!current) return

    current.handlers.delete(handler)
    if (current.handlers.size === 0 && window[name] === current.dispatcher) {
      if (current.previous) window[name] = current.previous
      else delete window[name]
      dispatchers.delete(name)
    }
  }
}
